<template>
  <v-alert
      class="text-center"
      :value="!!alertType"
      :type="alertType">
    {{ textAlert }}
  </v-alert>
</template>

<script>
  import { REQUEST_STATUSES } from '@/constants/business'

  export default {
    props: {
      requestStatus: {
        type: String
      },
      processComment: {
        type: String
      }
    },
    computed: {
      alertType () {
        const status = this.requestStatus
        switch (status) {
        case REQUEST_STATUSES.CREATED:
        case REQUEST_STATUSES.INPROCESS:
          return 'info'
        case REQUEST_STATUSES.APPROVED:
          return 'success'
        case REQUEST_STATUSES.REJECTED:
          return 'error'
        default:
          return null
        }
      },
      textAlert () {
        const status = this.requestStatus
        switch (status) {
        case REQUEST_STATUSES.CREATED:
          return this.$t('Регистрация не завершена. Для завершения пройдите все шаги регистрации и отправьте запрос.')
        case REQUEST_STATUSES.INPROCESS:
          return this.$t('Запрос подан и находится в обработке у администратора.')
        case REQUEST_STATUSES.APPROVED:
          return this.$t('Запрос на регистрацию пользователя в организации одобрен Организатором.')
        case REQUEST_STATUSES.REJECTED:
          const comment = this.processComment
            ? this.processComment
            : this.$t('не указана.')
          return this.$t('Запрос на регистрацию пользователя в организации отклонен Организатором. Причина') + ': ' + comment
        default:
          return null
        }
      }
    }
  }
</script>
